import QuestionAdditionalInformation from "pages/QuestionPage/QuestionAdditionalInformation/QuestionAdditionalInformation";

export default QuestionAdditionalInformation;
